import React, { useEffect, useRef } from "react"
import cycling_postman_animation from "animations/cycling-postman-animation.json"
import lottie from "lottie-web"

export const FetchZipModal = ({
  fetch_zip_modal_open,
  set_fetch_zip_modal_open,
}) => {
  const animationContainer = useRef()
  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: animationContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: cycling_postman_animation,
    })
    return () => anim.destroy() // optional clean up for unmounting
  }, [])

  const close_zip_fetch_modal = () => set_fetch_zip_modal_open(false)
  return (
    <div className={`modal${fetch_zip_modal_open ? " is-active" : ""}`}>
      <div
        className="modal-background"
        onClick={close_zip_fetch_modal}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
        aria-label="Close CTA Modal"
      ></div>
      <div className="modal-content">
        <div
          className="box mx-auto is-flex is-flex-direction-column"
          style={{ maxWidth: 600, minHeight: 350 }}
        >
          <p className="title is-5 mb-2 has-text-mitternachtsblau">
            Dateien werden vorbereitet
          </p>
          <hr className="is-mitternachtsblau-30 my-3" />
          <div
            className="has-text-mitternachtsblau mb-5 content"
            style={{ minHeight: 200 }}
          >
            Einen Moment Geduld bitte...
            <div
              className="m-auto"
              style={{ maxWidth: 400, minHeight: 340 }}
              ref={animationContainer}
            ></div>
          </div>
          <div className="buttons ml-auto">
            <button
              className="is-mitternachtsblau is-outlined button has-text-weight-bold"
              onClick={close_zip_fetch_modal}
            >
              Schließen
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
